var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.2732 79.2867L85.6381 64.815L85.4568 64.5861C82.9967 60.7196 81.404 56.3008 80.8363 51.7873L77.4459 24.6982C76.3105 15.537 70.7361 7.50414 62.5439 3.21155C58.5148 1.1126 53.9969 0 49.4789 0C44.961 0 40.4352 1.1126 36.4061 3.21155C28.2139 7.50414 22.6474 15.537 21.5041 24.6982L18.1216 51.7873C17.5223 56.5217 15.8113 61.1221 13.1779 65.0911L3.71624 79.2867C2.84104 80.6123 2.76219 82.2931 3.51124 83.674C4.2524 85.0706 5.6953 85.9386 7.288 85.9386H33.1734C34.3719 93.9872 41.3025 100 49.5026 100C57.7027 100 64.6333 93.9951 65.8318 85.9386H91.7172C93.302 85.9386 94.7528 85.0706 95.4861 83.6818C96.2351 82.2931 96.1642 80.6123 95.2811 79.2867H95.2732Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellFilled);
export default __webpack_public_path__ + "static/media/bell-filled.bd096e98de9d7bfd97f89b0826a147f5.svg";
export { ForwardRef as ReactComponent };